import { Container } from 'pixi.js';
import { titleStyle } from './fileStyle';
import { TranslationText } from './TranslationText';
import { MonoBehavior } from 'game/core/monoBehavior';
import { Layout } from 'game/LayoutManager';
import { Displays } from 'constants/layout';

export class Title extends MonoBehavior {
    public titleText: TranslationText;
    container: Container;
    key: string;

    constructor(translationKey: string) {
        super();
        this.container = new Container();
        this.key = translationKey;

        this.titleText = new TranslationText(this.key, titleStyle);
        this.titleText.setAnchor(0, 0.5);
        this.container.addChild(this.titleText.text);
    }

    resize(width: number, height: number): void {
        switch (Layout.getDisplay()) {
            case Displays.MOBILE:
                this.container.position.set(-172, 31);

                break;
            case Displays.TABLET:
                this.container.position.set(-172, 39);

                break;
            case Displays.DESKTOP:
                this.container.position.set(-172, 40);

                break;
        }
    }
}
